import {
  ClockControlSettings,
  ClockControlType,
  TournamentMode,
  TournamentSystem,
} from '@features/shared/api/typings';
import { TIME_CONTROL } from '@features/shared/constants';

type Props = {
  tournament?: {
    system: TournamentSystem;
    mode: TournamentMode;
    clockControl: ClockControlType;
    clockControlSettingsPlayer1: ClockControlSettings;
    clockControlSettingsPlayer2: ClockControlSettings;
  };
  variant?: 'all' | 'time-only';
};

export function EventClockControl({ tournament, variant }: Props) {
  if (!tournament) return null;

  const isMatch = tournament.system === 'OneOnOne' || tournament.system === 'Seance';
  const player1 = tournament.clockControlSettingsPlayer1;
  const player2 = tournament.clockControlSettingsPlayer2;

  if (!tournament.clockControl) {
    return null;
  }

  let timings = '';
  const clockControl = TIME_CONTROL[tournament.clockControl];
  if (player1?.initialSeconds !== undefined && player1?.addSecondsPerMove !== undefined) {
    timings += `${Math.floor(player1.initialSeconds / 60)}\u00A0+\u00A0${player1.addSecondsPerMove}`;
  }

  if (
    isMatch &&
    tournament.mode === 'Private' &&
    player2 &&
    (player1?.initialSeconds !== player2.initialSeconds ||
      player1?.addSecondsPerMove !== player2?.addSecondsPerMove)
  ) {
    timings += `, ${Math.floor(player2.initialSeconds / 60)}\u00A0+\u00A0${player2.addSecondsPerMove}`;
  }

  if (variant === 'time-only') {
    return timings;
  }

  return `${clockControl},\u00A0${timings}`;
}
